import React, {Component} from 'react';
import TableCell from "@amzn/meridian/table/table-cell";
import {FormattedMessage} from "react-intl";

/**
 * This class is currently used by floor view to show the details for an OV cart
 */
export default class OvCartTableCell extends Component {
    render() {

        const cart = this.props.cart

        return (
            <TableCell columnSpan={4}>
                <FormattedMessage id="ovCart.ovCart" defaultMessage="OV Cart"/> {cart.label} ({cart.childCount})
                packages
            </TableCell>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/floor/OvCartTableCell.js